<template>
  <div class="add-image-box">
    <el-dialog
      :title="'上传图片'"
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      append-to-body
      :close-on-click-modal="false">
      <el-form ref="form" :model="editParam" label-width="300px">
        <div class="form-flex-box">
          <el-form-item label="" prop="cover">
            <base-upload
              :cover="editParam.cover"
              :action="action"
              @successCallback="successCallback"
              @changeImgUrl='changeImgUrl'
              :id="sourceID"
              :wSize="360"
              :hSize="640"
              :width="'120px'"
              :height="'213px'"
            ></base-upload>
          </el-form-item>
        </div>
        图片地址: <span>{{ editParam.cover ? editParam.imgUrl + editParam.cover : null }}</span>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      dialogVisible: false,
      flag: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      sourceID: "",
      editParam: {
        imgUrl: baseConfig.imgUrl,
        cover: "",
        coverThumb: "",
      },
    };
  },
  methods: {
    // 标签封面上传成功回掉
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open() {
      this.dialogVisible = true;
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    changeImgUrl(data) {
      this.editParam.cover = data;
      this.editParam.coverThumb = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-image-box {
  .el-input {
    width: 150px;
  }
  .flex-item {
    width: 90%;
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
    .item-box {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>